module.exports = __webpack_public_path__ + "static/img/4435_phase_function_Paper_PointsHejduk_Prediction.f464890.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4435_phase_function_Paper_PointsHejduk_Prediction.png
// module id = pytY
// module chunks = 0